(function () {
  'use strict';

  var cfg = window.ShippingProtectionConfig;
  if (!cfg || !cfg.variantId) return;

  var VARIANT = cfg.variantId;
  var OPT_OUT_KEY = 'sp_opted_out';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function optedOut() {
    try { return localStorage.getItem(OPT_OUT_KEY) === '1'; } catch (e) { return false; }
  }
  function setOptOut(v) {
    try { v ? localStorage.setItem(OPT_OUT_KEY, '1') : localStorage.removeItem(OPT_OUT_KEY); } catch (e) {}
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Mirror the theme's Section Rendering targets so add/remove refreshes the same DOM.
  function renderTargets() {
    var t = [];
    if (document.getElementById('CartDrawer')) t.push({ elId: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
    if (document.getElementById('cart-icon-bubble')) t.push({ elId: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    if (document.getElementById('cart-live-region-text')) t.push({ elId: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' });
    var mci = document.getElementById('main-cart-items');
    if (mci) t.push({ elId: 'main-cart-items', section: mci.dataset.id, selector: '.js-contents' });
    var mcf = document.getElementById('main-cart-footer');
    if (mcf) t.push({ elId: 'main-cart-footer', section: mcf.dataset.id, selector: '.js-contents' });
    return t;
  }

  function inject(sections) {
    if (!sections) return;
    renderTargets().forEach(function (t) {
      var html = sections[t.section];
      if (!html) return;
      var source = new DOMParser().parseFromString(html, 'text/html').querySelector(t.selector);
      var host = document.getElementById(t.elId);
      if (!source || !host) return;
      var dest = host.querySelector(t.selector) || host;
      dest.innerHTML = source.innerHTML;
    });
  }

  function sectionParams() {
    var names = renderTargets().map(function (t) { return t.section; });
    return names.filter(function (v, i) { return names.indexOf(v) === i; });
  }

  function post(url, body) {
    body.sections = sectionParams();
    body.sections_url = window.location.pathname;
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function afterChange(data) {
    inject(data && data.sections);
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shipping-protection' });
      }
    } catch (e) {}
  }

  function addProtection() {
    return post('cart/add.js', { items: [{ id: VARIANT, quantity: 1 }] }).then(afterChange);
  }

  function removeProtection(cart) {
    var line = cart.items.filter(function (i) { return i.variant_id === VARIANT; })[0];
    if (!line) return Promise.resolve();
    return post('cart/change.js', { id: line.key, quantity: 0 }).then(afterChange);
  }

  // Auto-add when the cart has other items and the customer hasn't opted out.
  // Remove protection if it would be the only thing left in the cart.
  function evaluate() {
    if (busy) return Promise.resolve();
    busy = true;
    return getCart().then(function (cart) {
      var hasP = cart.items.some(function (i) { return i.variant_id === VARIANT; });
      var otherQty = cart.items.reduce(function (n, i) { return i.variant_id === VARIANT ? n : n + i.quantity; }, 0);
      if (otherQty > 0 && !hasP && !optedOut()) return addProtection();
      if (otherQty === 0 && hasP) return removeProtection(cart);
      return null;
    }).catch(function () {}).then(function () { busy = false; });
  }

  // Toggle handler (delegated so it survives cart re-renders).
  document.addEventListener('change', function (e) {
    var input = e.target && e.target.closest && e.target.closest('.js-shipping-protection-toggle');
    if (!input || busy) return;
    busy = true;
    input.disabled = true;
    var action;
    if (input.checked) { setOptOut(false); action = addProtection(); }
    else { setOptOut(true); action = getCart().then(removeProtection); }
    Promise.resolve(action).catch(function () {}).then(function () { busy = false; });
  });

  // Re-evaluate when the cart changes elsewhere (quantity change, add, remove).
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.source === 'shipping-protection') return;
        evaluate();
      });
    }
  } catch (e) {}

  if (document.readyState !== 'loading') evaluate();
  else document.addEventListener('DOMContentLoaded', evaluate);
})();
